<!-- ======= Breadcrumbs ======= -->
<section class="breadcrumbs">
    <div class="container">

        <div class="d-flex justify-content-between align-items-center">
            <h2>What is tpl </h2>
           
              <p-breadcrumb [model]="items"></p-breadcrumb>
            <!------ <ol>
                    <li [model]="items"><a href="index.html">Home</a></li>
                    <li>Products </li>
                </ol>
            -->
        </div>
    </div>
</section>
<!-- End Breadcrumbs -->
<div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="secure-shopping about-fasinating-diamond">
        <p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="carouselResponsiveOptions">
            <ng-template let-banner pTemplate="item">
                <div class="product-item">
                    <div class="product-item-content">
                        <div class="p-mb-1 banner-item-main">
                            <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="container-fluid p-0">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                 
                   
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div>